var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { stringify } from 'qs';
import { axiosInstance } from '@/api/realApi/_axios';
import { joinUrl } from '@/api/realApi/_utils';
import { getCsrfHeaders } from '@/api/realApi/authApi';
const ABILITIES_URL_PATH = '/api/abilities/';
export const spellsApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([ABILITIES_URL_PATH, '/spells/']), {
            params,
            paramsSerializer: (params) => stringify(params, { arrayFormat: 'comma' }),
        });
        return res.data['results'] || res.data;
    }),
    update: (params, spell) => __awaiter(void 0, void 0, void 0, function* () {
        const csrfConfig = yield getCsrfHeaders();
        const config = Object.assign(Object.assign({}, csrfConfig), { params, paramsSerializer: (params) => stringify(params, { arrayFormat: 'comma' }) });
        const res = yield axiosInstance.post(joinUrl([ABILITIES_URL_PATH, '/spells/']), spell, config);
        return res.data;
    }),
};
export const characterSpellsCollectionApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([ABILITIES_URL_PATH, '/spells/character-spells/']), {
            params,
            paramsSerializer: (params) => stringify(params, { arrayFormat: 'comma' }),
        });
        return res.data['results'] || res.data;
    }),
    create: (spellsCollection) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([ABILITIES_URL_PATH, '/spells/character-spells/']), spellsCollection, config);
        return res.data;
    }),
    update: (spellsCollection) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.patch(joinUrl([ABILITIES_URL_PATH, '/spells/character-spells/', spellsCollection.id]), spellsCollection, config);
        return res.data;
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.delete(joinUrl([ABILITIES_URL_PATH, '/spells/character-spells/', id]), config);
    }),
};
